import ChargerTariffs from "./chargerTariffs";
export default ChargerTariffs